import { AccountType } from 'further-types/investor';
import { ShareholdingAllocationRow } from 'further-ui/utils';
import { FundAllocation } from '..';

export const transformFundAllocationsToSpreadsheetData = (
  formFundAllocations: Array<FundAllocation>,
) => {
  const spreadsheetData: Array<ShareholdingAllocationRow> = [];

  formFundAllocations.forEach((fundAllocation) => {
    fundAllocation.investments.forEach((investment) => {
      // Calculate transaction fee and VAT
      const transactionFee = investment.transactionFeeAmount;
      const transactionFeeVat =
        investment.defaultTransactionFeeVatPercent / 100;

      const containsAdjustedValue =
        investment.adjustedNetInvestmentExFee !==
        investment.finalShareholding * fundAllocation.dealSharePrice;

      spreadsheetData.push({
        tranche: fundAllocation.trancheName,
        registeredName: investment.investor.fullName,
        firstName: investment.investor.firstName,
        middleName: investment.investor.middleName,
        lastName:
          investment.investor.accountType === AccountType.LegalEntity
            ? investment.investor.registeredName ?? ''
            : investment.investor.lastName,
        subscriptionDate: investment.investmentDate.toISOString(),
        sharesAllocated: investment.finalShareholding,
        capitalAllocated:
          investment.finalShareholding * fundAllocation.dealSharePrice,
        capitalAllocatedAdjusted: containsAdjustedValue
          ? investment.adjustedNetInvestmentExFee
          : undefined,
        transactionFee,
        transactionFeeVat,
        deployableCapitalPre: investment.investmentCapitalRemaining,
        deployableCapitalPost: 0, // Will be calculated by spreadsheet formulas
        finalDeal: fundAllocation.finalDeal ? 'Yes' : '',
        externalInvestmentId: investment.externalInvestmentId ?? '',
        systemInvestmentId: investment.investmentId,
        companyId: fundAllocation.companyId,
        trancheId: fundAllocation.trancheId,
        firmId: investment.firmId,
      });
    });
  });

  return spreadsheetData;
};
